var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRepeat = function SvgRepeat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8586 5.74212L13.7457 6.90954C14.28 7.77343 14.5714 8.77741 14.5714 9.82808C14.5714 13.0502 11.8514 15.6652 8.5 15.6652C5.14857 15.6652 2.42857 13.0502 2.42857 9.82808C2.42857 6.72275 4.95429 4.17778 8.13571 3.991C8.13571 4.22448 8.13571 4.45796 8.13571 4.69145V5.32185C8.13571 5.83552 8.52429 6.04565 8.98571 5.78882L10.2971 5.06502C10.7586 4.80819 11.5114 4.38792 11.9729 4.13109L13.2843 3.40729C13.7457 3.15046 13.7457 2.73019 13.2843 2.47336L11.9729 1.74956C11.5114 1.49273 10.7586 1.07246 10.2971 0.815624L8.98571 0.115174C8.52429 -0.141658 8.13571 0.045129 8.13571 0.535444C8.13571 0.862321 8.13571 1.28259 8.13571 1.65616C3.61857 1.84295 0 5.43859 0 9.82808C0 14.3343 3.81286 18 8.5 18C13.1871 18 17 14.3343 17 9.82808C17 8.33379 16.5871 6.95624 15.8586 5.74212Z",
    fill: "#4C525E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRepeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/repeat.10b68d7e.svg";
export { ForwardRef as ReactComponent };